import * as React from 'react'

import { Radio } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { FLOWS } from 'modules/contracts/components/FlowSelectorModal/constants'

import Label from 'modules/contracts/components/FlowSelectorModal/Label'

interface Props {
  title: string
  value: string
  onChange: (option: React.SetStateAction<string>) => void
  withoutContracts: boolean
}

const CreateRadioOption = ({ title, value, onChange, withoutContracts }: Props) => {
  return (
    <Radio
      name={title}
      value={value}
      onChange={(option) => onChange(option)}
      description={i18n.t(
        'contract_versions.modals.quick_flows.create_without_contracts.description'
      )}
      option={{
        label: <Label icon="contract" text={title} />,
        value: withoutContracts ? FLOWS.creation : FLOWS.evolution,
      }}
    />
  )
}

export default CreateRadioOption
